var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
// AUTO-GENERATED CONTENT - DO NOT MANUALLY EDIT - Run 'yarn generate:assets' to update
import Asset from '../asset-internal';
function JuliaLogomark(_a) {
    var restProps = __rest(_a, []);
    return (_jsx(Asset, Object.assign({ viewBox: "0 0 40 40" }, restProps, { children: _jsx("path", { fill: "currentColor", fillRule: "evenodd", clipRule: "evenodd", d: "M28.227 11.348A8.227 8.227 0 0 1 20 19.575a8.227 8.227 0 1 1 0-16.453 8.227 8.227 0 0 1 8.227 8.226zm-18.114 8.65c-4.544 0-8.227 3.683-8.227 8.227s3.683 8.227 8.227 8.227 8.227-3.683 8.227-8.227-3.683-8.227-8.227-8.227zm19.774 0c-4.544 0-8.227 3.683-8.227 8.227s3.683 8.227 8.227 8.227 8.227-3.683 8.227-8.227-3.684-8.227-8.227-8.227z" }) })));
}
export default JuliaLogomark;
